import { render, staticRenderFns } from "./ImageAdsOnlyDisclaimer.vue?vue&type=template&id=4a51e156"
import script from "./ImageAdsOnlyDisclaimer.vue?vue&type=script&lang=js"
export * from "./ImageAdsOnlyDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports